import React from 'react';

import { AuthHeader } from '@/features/auth/components/auth-header';
import {
  FlowLayout,
  FlowLayoutProps,
} from '@/shared/components/flow/flow-layout';
import { Background } from '@/shared/components/layouts/background';
import { Head } from '@/shared/components/seo';

type LayoutProps = {
  children: React.ReactNode;
  title: string;
  headerActions?: React.ComponentProps<typeof AuthHeader>['actions'];
} & FlowLayoutProps;

export const AuthLayout = ({
  children,
  title,
  headerActions,
  stepper,
}: LayoutProps) => {
  return (
    <>
      <Head title={title} />
      <Background>
        <div className="fixed left-6 right-6 top-6 lg:left-12 lg:right-0 lg:top-12">
          <AuthHeader actions={headerActions} />
        </div>
        <FlowLayout stepper={stepper}>{children}</FlowLayout>
      </Background>
    </>
  );
};
